import { CountBadge, IconButton } from '@vrplatform/components';
import { useIntercom, useTeam } from '@vrplatform/data';
import { CommentQuestionIcon } from '@vrplatform/icons';
import {
  Text,
  Tooltip,
  UnstyledButton,
  rem,
  useMantineTheme,
} from '@mantine/core';
import { useNavbarExpanded } from '../../../hooks';

export const NavbarSupportButton = () => {
  const [{ isGL: GL }] = useTeam();
  const { unreadMessagesCount, helperVisible, setHelperVisible, isBooted } =
    useIntercom();
  const label = helperVisible ? 'Hide support helper' : 'Show support helper';

  const { colors } = useMantineTheme();

  const color = colors.neutral[0];

  const { isDesktopExpanded } = useNavbarExpanded();

  const disabled = !isBooted;

  if (GL || !isDesktopExpanded) {
    return (
      <IconButton
        onClick={() => setHelperVisible(!helperVisible)}
        disabled={disabled}
        aria-pressed={helperVisible}
        icon="CommentQuestionIcon"
        color={(theme) => theme.colors.neutral[3]}
        count={unreadMessagesCount}
        tooltip={label}
        sx={
          disabled
            ? {
                opacity: 0.5,
                backgroundColor: 'transparent',
                ':hover': {
                  backgroundColor: 'transparent',
                },
              }
            : undefined
        }
      />
    );
  }

  return (
    <Tooltip label={label} withArrow>
      <UnstyledButton
        type="button"
        onClick={() => setHelperVisible(!helperVisible)}
        disabled={disabled}
        aria-label={label}
        aria-pressed={helperVisible}
        mx="xs"
        px={'xs'}
        py={5}
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing.xs,
          marginBottom: rem(5),
          cursor: !disabled ? 'pointer' : 'not-allowed',
          opacity: !disabled ? 1 : 0.5,
          border: 0,
          width: 'calc(100% - 2 * var(--mantine-spacing-xs))',
          backgroundColor: helperVisible
            ? theme.colors[theme.primaryColor][9]
            : 'transparent',
          transition: 'background-color 0.1s ease-in-out',
          borderRadius: theme.radius.md,
          ':active': {
            transform: 'translateY(1px)',
          },
          ':hover': {
            backgroundColor: disabled
              ? 'transparent'
              : theme.colors[theme.primaryColor][9] + 40,
          },
        })}
      >
        <CommentQuestionIcon size={18} color={color} />
        <Text c={color} component="span" size={'sm'}>
          Help & Support
        </Text>
        {unreadMessagesCount ? (
          <CountBadge
            count={unreadMessagesCount}
            size={'0.75rem'}
            sx={{ marginLeft: 'auto' }}
          />
        ) : null}
      </UnstyledButton>
    </Tooltip>
  );
};
